"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClubInvoicePage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const club_invoice_1 = require("../../sections/club-invoice");
const ClubInvoiceContext_1 = require("../../sections/club-invoice/context/ClubInvoiceContext");
const ClubInvoicePage = () => {
    return ((0, jsx_runtime_1.jsx)(ClubInvoiceContext_1.ClubInvoiceProvider, { children: (0, jsx_runtime_1.jsx)(club_invoice_1.ClubInvoiceComponent, {}) }));
};
exports.ClubInvoicePage = ClubInvoicePage;
